<template>
  <div class="flex flex-col justify-between bg-white p-8 h-full author-card">
    <div>
      <div class="flex items-center">
        <div class="items-center">
          <BaseAvatar
            :img="props.data.image"
            class="md:mr-1 w-[75px] h-[75px] mr-4"
          ></BaseAvatar>
        </div>
        <div class="">
          <NuxtLinkLocale :locale="switchBlogLocale(true)" :to="authorUrl">
            <h3 class="text-secondary break-word hover:underline">
              {{ props.data.display_name }}
            </h3>
            <span class="text-dark-blue-light text-blog-14 font-semibold">
              {{ props.data.designation }}
            </span>
          </NuxtLinkLocale>
        </div>
      </div>
      <p class="my-6 text-blog-14-sm">
        {{ props.data.short_info }}
      </p>
    </div>
    <div class="flex justify-center font-bold text-secondary">
      <NuxtLinkLocale :locale="switchBlogLocale(true)" :to="authorUrl">
        <button class="border rounded px-10 py-1 border-secondary">
          {{ $t("blog.authorBioBtn") }}
        </button>
      </NuxtLinkLocale>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
  },
});

const authorUrl = `/blog/authors/${props.data.slug}`;
</script>
<style scoped>
.author-card {
  box-shadow: 0px 3px 6px #00000033;
}
</style>
